/**
 * The protocol step as the Live Activity receives it, from the shared
 * `liveSession.protocol` the program screen writes each tick.
 *
 * Pure on purpose: the hook that calls it lives inside Vue (inject, i18n) and
 * cannot be exercised from a plain node test; this can.
 *
 * `endsAt` lets native run the countdown itself between two updates; while
 * paused the widget shows `remaining` frozen instead, so both are sent.
 */

import { pad } from './numeric.js'

const mmss = (seconds) => {
    const s = Math.max(0, Math.round(Number(seconds) || 0))
    return `${pad(Math.floor(s / 60))}:${pad(s % 60)}`
}

export function buildLiveActivityStep(protocol, { label, colours = {}, now = Date.now() } = {}) {
    if (!protocol?.gait) return {}

    const remaining = Math.max(0, Math.round(Number(protocol.remaining) || 0))

    const step = {
        stepLabel: label(protocol.gait),
        stepColor: colours[protocol.gait] ?? null,
        stepPosition: protocol.position ?? null,
        stepRemaining: remaining,
        stepEndsAt: now + remaining * 1000,
    }

    // What comes after this gait, so the lock screen reads like the phone:
    // the next gait and its length, or nothing when this is the last one.
    if (protocol.next?.gait) {
        step.nextStepLabel = label(protocol.next.gait)
        step.nextStepDuration = mmss(protocol.next.duration)
    }

    return step
}
